module.exports = __webpack_public_path__ + "img/sw.563908a2.png";